import type { ReactNode } from "react"

import { FundReadyHeader } from "@/components/fundready/FundReadyHeader"
import { Button, LoadingButton } from "@/components/ui/button"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { Progress } from "@/components/ui/progress"

type StepShellProps = {
  step: number
  totalSteps: number
  title: string
  description?: string
  children: ReactNode
  onBack?: () => void
  backDisabled?: boolean
  onContinue: () => void
  continueLabel?: string
  continuePending?: boolean
}

export function StepShell({
  step,
  totalSteps,
  title,
  description,
  children,
  onBack,
  backDisabled = false,
  onContinue,
  continueLabel = "Continue",
  continuePending = false,
}: StepShellProps) {
  return (
    <div>
      <FundReadyHeader />
      <div className="mx-auto flex max-w-4xl flex-col gap-4 p-8">
        <Progress value={(step / totalSteps) * 100} className="h-2" />

        <Card className="shadow-md">
          <CardHeader className="pb-2">
            <CardTitle className="text-3xl font-extrabold tracking-tight">
              {title}
            </CardTitle>
            {description && (
              <p className="text-muted-foreground text-base">{description}</p>
            )}
          </CardHeader>
          <CardContent className="fr-step-questions flex flex-col gap-7 px-8 pb-8">
            {children}

            <div className="flex justify-between pt-2">
              {onBack ? (
                <Button
                  type="button"
                  variant="outline"
                  onClick={onBack}
                  disabled={backDisabled}
                >
                  Back
                </Button>
              ) : (
                <span />
              )}
              {continuePending ? (
                <LoadingButton type="button">{continueLabel}</LoadingButton>
              ) : (
                <Button type="button" onClick={onContinue}>
                  {continueLabel}
                </Button>
              )}
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}
